import {AbstractControl, ValidationErrors} from '@angular/forms';
import {extractPlainText} from '../utils/ngx-editor-utils';

export class NgxEditorValidators {

    static ngxEditorPlainTextMaxLengthValidator(maxLength: number): (control: AbstractControl) => ValidationErrors | null {
        return (control: AbstractControl): ValidationErrors | null => {
            const value = control.value;
            if (!value) {
                return null;
            }
            const plainText = extractPlainText(value).replace(/\s+/g, ' ').trim();
            return plainText.length <= maxLength
                ? null
                : {maxLength: {requiredLength: maxLength, actualLength: plainText.length}};
        };
    }

    static ngxEditorPlainTextRequiredValidator(control: AbstractControl): ValidationErrors | null {
        const value = control.value;
        if (!value) {
            return {required: true};
        }
        const plainText = extractPlainText(value).replace(/\s+/g, ' ').trim();
        return plainText ? null : {required: true};
    }

}
